import { useEffect, useState } from 'react';

export default function AboutHero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 200);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full min-h-screen flex items-end overflow-hidden" style={{ background: '#0d0d0d' }}>
      {/* Giant background word */}
      <span
        className="boldonse absolute select-none pointer-events-none"
        style={{
          fontSize: '52vw',
          lineHeight: 1,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -48%)',
          color: 'rgba(255,255,255,0.03)',
          letterSpacing: '-8px',
          whiteSpace: 'nowrap',
        }}
      >
        US
      </span>

      {/* Content */}
      <div className="relative z-10 px-10 lg:px-20 pt-40 pb-24 max-w-2xl">
        <div className={`transition-all duration-1000 delay-200 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
          <p className="text-[#F8CA9D] text-xs tracking-[0.5em] uppercase mb-10 font-medium">
            &#8212;&nbsp;&nbsp;Our story&nbsp;&nbsp;&#8212;
          </p>
          <h1
            className="boldonse text-white leading-none mb-8"
            style={{ fontSize: 'clamp(64px, 9vw, 130px)', lineHeight: 0.88 }}
          >
            BUILT<br />
            <span style={{ color: '#FA6E4F' }}>FOR.</span><br />
            <span style={{ WebkitTextStroke: '2px rgba(255,255,255,0.3)', color: 'transparent' } as React.CSSProperties}>
              SCALE.
            </span><br />
            <span style={{ color: '#8EC9BB' }}>GROWTH.</span>
          </h1>
        </div>
        <div className={`transition-all duration-1000 delay-500 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
          <p className="text-white/60 text-lg leading-relaxed max-w-md">
            We are an IT company specialising in software development for businesses and private users, as well as comprehensive turnkey digital solutions.
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 flex flex-col items-center gap-2">
        <span className="text-white/30 text-xs tracking-[0.3em] uppercase">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/30 to-transparent animate-pulse" />
      </div>
    </section>
  );
}